import { MDXProvider } from '@mdx-js/react';
import type { ReactNode } from 'react';

import { GraphQLPlaygroundProvider } from './graphqlPlayground.tsx';
import { mdxComponents } from './mdxComponents.tsx';

interface MdxProviderProps {
  children: ReactNode;
  graphqlPlayground: string;
}

export const MdxProvider = ({
  children,
  graphqlPlayground,
}: MdxProviderProps) => (
  <GraphQLPlaygroundProvider value={graphqlPlayground}>
    <MDXProvider components={mdxComponents}>{children}</MDXProvider>
  </GraphQLPlaygroundProvider>
);
